exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-title[data-v-33858d9f]{font-size:30px;font-weight:900}.qr-wrapper[data-v-33858d9f] img{margin:0 auto}.use-link-text[data-v-33858d9f]{font-size:18px}.kaspi-link[data-v-33858d9f]{color:#f14635!important}.modal-content .close[data-v-33858d9f]{position:absolute;right:15px;top:15px}.kaspi-price[data-v-33858d9f]{text-align:center;font-weight:700;font-size:32px}.kaspi-pay-type[data-v-33858d9f]{font-size:18px}.kaspi-pay-type img[data-v-33858d9f]{margin-top:8px}@media only screen and (max-width:768px){.modal-title[data-v-33858d9f]{font-size:24px}}", ""]);

// exports
